import Cookies from 'js-cookie';
import { message } from 'antd';
import actions from './actions';
import { DataService } from '../../config/dataService/dataService';

const {
  loginBegin,
  loginSuccess,
  loginErr,
  logoutBegin,
  logoutSuccess,
  logoutErr,
  forgotBegin,
  forgotSuccess,
  forgotErr,
  passwordBegin,
  passwordSuccess,
  passwordErr,
} = actions;

const login = (values, callback) => {
  return async (dispatch) => {
    dispatch(loginBegin());

    try {
      const response = await DataService.post('/user/login/', values);

      if (response.data.status === true) {
        // Amazon DPP §1.4: If MFA is required, invoke callback with MFA session details
        if (response.data.mfa_required) {
          dispatch(loginErr(null));
          callback({
            mfa_required: true,
            email: values.email,
            ...response.data.data,
            message: response.data.message,
          });
          return;
        }

        message.success('Login successful');

        // Store tokens
        Cookies.set('access_token', response.data.data.access);
        Cookies.set('refresh_token', response.data.data.refresh);
        Cookies.set('logedIn', 'true');

        // Store user email for display purposes
        Cookies.set('userEmail', values.email);

        // Get subscription status from response
        const hasSubscription = response.data.data.has_subscription === true;
        Cookies.set('hasSubscription', hasSubscription ? 'true' : 'false');

        // Dispatch login success, user profile, and subscription status
        dispatch(loginSuccess(true));
        dispatch(actions.setUserProfile(response.data.data));
        dispatch(actions.setHasSubscription(hasSubscription));

        const userData = response.data.data;
        const isSuperAdmin =
          userData.is_superuser ||
          userData.is_staff ||
          userData.role === 'Admin' ||
          (!userData.is_client_user && userData.role !== 'Client');

        const freeTrailUse =
          userData?.free_trail_use === true ||
          userData?.free_trail_use === 'true' ||
          userData?.free_trail_use === 1 ||
          userData?.free_trial_use === true ||
          userData?.free_trial_use === 'true' ||
          userData?.free_trial_use === 1;

        Cookies.set('free_trail_use', freeTrailUse ? 'true' : 'false', { path: '/' });
        localStorage.setItem('free_trail_use', freeTrailUse ? 'true' : 'false');
        Cookies.set('isSuperAdmin', isSuperAdmin ? 'true' : 'false');

        callback(userData);
      }
    } catch (err) {
      const errorMessage = err.response?.data?.error || 'Something went wrong';
      dispatch(loginErr(errorMessage));
    }
  };
};

const verifyMFA = (payload, callback) => {
  return async (dispatch) => {
    dispatch(loginBegin());

    try {
      const response = await DataService.post('/user/mfa/verify/', payload);

      if (response.data.status === true) {
        message.success(response.data.message || 'Login successful');

        const userData = response.data.data;

        Cookies.set('access_token', userData.access, { path: '/' });
        Cookies.set('refresh_token', userData.refresh, { path: '/' });
        Cookies.set('logedIn', 'true', { path: '/' });
        Cookies.set('userEmail', userData.email, { path: '/' });

        const hasSubscription = userData.has_subscription === true;
        Cookies.set('hasSubscription', hasSubscription ? 'true' : 'false', { path: '/' });

        dispatch(loginSuccess(true));
        dispatch(actions.setUserProfile(userData));
        dispatch(actions.setHasSubscription(hasSubscription));

        const isSuperAdmin =
          userData.is_superuser ||
          userData.is_staff ||
          userData.role === 'Admin' ||
          (!userData.is_client_user && userData.role !== 'Client');

        const freeTrailUse =
          userData?.free_trail_use === true ||
          userData?.free_trail_use === 'true' ||
          userData?.free_trail_use === 1 ||
          userData?.free_trial_use === true ||
          userData?.free_trial_use === 'true' ||
          userData?.free_trial_use === 1;

        Cookies.set('free_trail_use', freeTrailUse ? 'true' : 'false', { path: '/' });
        localStorage.setItem('free_trail_use', freeTrailUse ? 'true' : 'false');
        Cookies.set('isSuperAdmin', isSuperAdmin ? 'true' : 'false', { path: '/' });

        callback(true, userData);
      } else {
        const errorMsg = response.data.error || 'Verification failed';
        dispatch(loginErr(errorMsg));
        callback(false, errorMsg);
      }
    } catch (err) {
      const errorMessage = err.response?.data?.error || 'Verification failed. Please check your code.';
      dispatch(loginErr(errorMessage));
      callback(false, errorMessage);
    }
  };
};

const resendMFAOTP = (payload, callback) => {
  return async () => {
    try {
      const response = await DataService.post('/user/mfa/resend/', payload);
      if (response.data.status === true) {
        callback(true, response.data.message);
      } else {
        callback(false, response.data.error || 'Failed to resend code');
      }
    } catch (err) {
      callback(false, err.response?.data?.error || 'Failed to resend code');
    }
  };
};

// const login = (values, callback) => {
//   return async (dispatch) => {
//     dispatch(loginBegin());

//     const { email, password } = values;

//     if (email === 'hexadash@dm.com' && password === '123456') {
//       Cookies.set('access_token', 'demo-token');
//       Cookies.set('loggedIn', 'true');
//       dispatch(loginSuccess(true));
//       callback();
//     } else {
//       dispatch(loginErr('Invalid credentials'));
//     }
//   };
// };

const register = (values, callback) => {
  return async (dispatch) => {
    dispatch(loginBegin());

    try {
      const response = await DataService.post('/user/register/', values);

      if (response.data.status === true) {
        dispatch(loginSuccess(false));
        callback(); // redirect to login page
      } else {
        const errorMessage = response.data.error || 'Registration failed';

        dispatch(loginErr(errorMessage));
      }
    } catch (err) {
      console.log('Register Failed:', err.response?.data);

      const errorMessage = err.response?.data?.error || 'Something went wrong';

      dispatch(loginErr(errorMessage));
    }
  };
};

const forgotPassword = (values, callback) => {
  return async (dispatch) => {
    dispatch(forgotBegin());

    try {
      const response = await DataService.post('/user/forgot-password/', values);

      // console.log('Forgot Password Success:', response.data);

      if (response.data.status === true) {
        dispatch(forgotSuccess(response.data.message));

        // ✅ Redirect or move to OTP page
        callback();
      } else {
        dispatch(forgotErr('Reset failed'));
      }
    } catch (err) {
      console.log('Forgot Password Failed:', err.response?.data);

      const errorMessage = err.response?.data?.error || 'Something went wrong';

      dispatch(forgotErr(errorMessage));
    }
  };
};

const resetPassword = (values, callback) => {
  return async (dispatch) => {
    dispatch(forgotBegin());

    try {
      const response = await DataService.post('/user/reset-password/', values);

      if (response.data.status === true) {
        dispatch(forgotSuccess(response.data.message));
        callback();
      } else {
        dispatch(forgotErr('Reset failed'));
      }
    } catch (err) {
      const errorMessage = err.response?.data?.error || 'Something went wrong';

      dispatch(forgotErr(errorMessage));
    }
  };
};

const changePassword = (values, callback) => {
  return async (dispatch) => {
    dispatch(passwordBegin());

    try {
      const response = await DataService.post('/user/change-password/', values);

      // console.log('Change Password Success:', response.data);

      if (response.data.status === true) {
        dispatch(passwordSuccess(response.data.message));
        callback();
      } else {
        dispatch(passwordErr(response.data.error || 'Password change failed'));
      }
    } catch (error) {
      const errorMessage = error.response?.data?.error || 'Something went wrong';

      dispatch(passwordErr(errorMessage));
    }
  };
};

const logOut = (callback) => {
  return async (dispatch) => {
    dispatch(logoutBegin());

    try {
      const refreshToken = Cookies.get('refresh_token');

      // Logout API call
      if (refreshToken) {
        await DataService.post('/user/logout/', {
          refresh: refreshToken,
        });
      }

      // Clear cookies after successful logout API call
      Cookies.remove('access_token');
      Cookies.remove('refresh_token');
      Cookies.remove('logedIn');
      Cookies.remove('hasSubscription');
      Cookies.remove('isSuperAdmin');
      Cookies.remove('userEmail');
      Cookies.remove('free_trail_use');

      dispatch(logoutSuccess(false));
      message.success('Logged out successfully');

      if (callback) {
        callback();
      }
    } catch (err) {
      console.log('Logout Failed:', err.response?.data || err);

      // Even if API fails, clear local session
      Cookies.remove('access_token');
      Cookies.remove('refresh_token');
      Cookies.remove('logedIn');
      Cookies.remove('hasSubscription');
      Cookies.remove('isSuperAdmin');
      Cookies.remove('userEmail');
      Cookies.remove('free_trail_use');

      dispatch(logoutErr(err));

      if (callback) {
        callback();
      }
    }
  };
};

const getProfile = () => {
  return async (dispatch, getState) => {
    const { profileLoading } = getState().auth;
    if (profileLoading) {
      return;
    }

    try {
      dispatch(actions.profileLoading(true));
      const response = await DataService.get('/user/profile/');
      if (response.data.status === true) {
        const userData = response.data.data || response.data;
        const freeTrailUse =
          userData?.free_trail_use === true ||
          userData?.free_trail_use === 'true' ||
          userData?.free_trail_use === 1 ||
          userData?.free_trial_use === true ||
          userData?.free_trial_use === 'true' ||
          userData?.free_trial_use === 1 ||
          response.data?.free_trail_use === true ||
          response.data?.free_trail_use === 'true';

        Cookies.set('free_trail_use', freeTrailUse ? 'true' : 'false', { path: '/' });
        localStorage.setItem('free_trail_use', freeTrailUse ? 'true' : 'false');
        dispatch(actions.setUserProfile(userData));
      }
    } catch (err) {
      console.log('Get Profile Failed:', err);
      dispatch(actions.profileErr(err));
    }
  };
};

const subUserLogin = (subUserId, callback) => {
  return async (dispatch) => {
    dispatch(loginBegin());

    try {
      const response = await DataService.post(`/user/sub-users/${subUserId}/login/`);

      if (response.data.status === true) {
        const userData = response.data.data;

        // Store tokens
        Cookies.set('access_token', userData.access, { path: '/' });
        Cookies.set('refresh_token', userData.refresh, { path: '/' });
        Cookies.set('logedIn', 'true', { path: '/' });
        Cookies.set('userEmail', userData.email, { path: '/' });

        const hasSubscription = userData.has_subscription === true;
        const isSuperAdmin =
          userData.is_superuser ||
          userData.is_staff ||
          userData.role === 'Admin' ||
          (!userData.is_client_user && userData.role !== 'Client');

        const freeTrailUse =
          userData.free_trail_use === true ||
          userData.free_trail_use === 'true' ||
          userData.free_trial_use === true ||
          userData.free_trial_use === 'true';
        Cookies.set('free_trail_use', freeTrailUse ? 'true' : 'false', { path: '/' });
        localStorage.setItem('free_trail_use', freeTrailUse ? 'true' : 'false');

        Cookies.set('hasSubscription', hasSubscription ? 'true' : 'false', { path: '/' });
        Cookies.set('isSuperAdmin', isSuperAdmin ? 'true' : 'false', { path: '/' });

        dispatch(loginSuccess(true));
        dispatch(actions.setUserProfile(userData));
        dispatch(actions.setHasSubscription(hasSubscription));

        if (callback) callback(userData);
      } else {
        dispatch(loginErr(response.data.message || 'Sub-user login failed'));
      }
    } catch (err) {
      console.log('Sub-User Login Failed:', err.response?.data);
      const errorMessage = err.response?.data?.error || err.response?.data?.message || 'Failed to login as sub-user';
      dispatch(loginErr(errorMessage));
    }
  };
};

const setUserProfile = (data) => {
  return (dispatch) => {
    dispatch(actions.setUserProfile(data));
  };
};

const sendSignupOTP = (values, callback) => {
  return async () => {
    try {
      const response = await DataService.post('/user/send-signup-otp/', values);
      if (response.data.status === true) {
        if (callback) callback(true, response.data);
      } else {
        const errorMessage = response.data.error || response.data.message || 'Failed to send OTP';
        if (callback) callback(false, errorMessage);
      }
    } catch (err) {
      console.log('Send OTP Failed:', err.response?.data);
      const errorMessage =
        err.response?.data?.error || err.response?.data?.message || 'Something went wrong while sending OTP';
      if (callback) callback(false, errorMessage);
    }
  };
};

const verifyResetOtp = (values, callback) => {
  return async (dispatch) => {
    dispatch(forgotBegin());

    try {
      const response = await DataService.post('/user/verify-reset-otp/', values);

      if (response.data.status === true) {
        dispatch(forgotSuccess(response.data.message));
        if (callback) callback(true, response.data.message);
      } else {
        const msg = response.data.error || response.data.message || 'OTP verification failed';
        dispatch(forgotErr(msg));
        if (callback) callback(false, msg);
      }
    } catch (err) {
      const errorMessage = err.response?.data?.error || err.response?.data?.message || 'Invalid or expired OTP';
      dispatch(forgotErr(errorMessage));
      if (callback) callback(false, errorMessage);
    }
  };
};

export {
  login,
  verifyMFA,
  resendMFAOTP,
  subUserLogin,
  logOut,
  register,
  sendSignupOTP,
  forgotPassword,
  verifyResetOtp,
  resetPassword,
  changePassword,
  getProfile,
  setUserProfile,
};
